import Component from './component';
import adPlayingIcon from '../../assets/icons/state-adplaying.svg';

const progressIndicatorRadius = 233;
const progressIndicatorCirc = progressIndicatorRadius * Math.PI * 2;
const progressIndicator = adPlayingIcon
  .replace('<path', '<path fill="var(--border)"')
  .replace('</svg>', `<circle class="iono-ad-progress" style="transform:rotate(-90deg); transform-origin: 50% 50%" r="${progressIndicatorRadius}" cx="50%" cy="50%" stroke="var(--text)" stroke-width="30" stroke-linecap="round" stroke-dashoffset="${progressIndicatorCirc}px" fill="transparent" stroke-dasharray="${progressIndicatorCirc}px"></circle></svg>`);

export default class Adstrip extends Component {
  constructor (options) {
    super(options);

    this.player = options.player;
    this.locale = this.player.getLayout().locale;

    this.onadstart = this.onadstart.bind(this);
    this.onadtimeupdate = this.onadtimeupdate.bind(this);
    this.onadskippable = this.onadskippable.bind(this);
    this.onskipclick = this.onskipclick.bind(this);
  }

  getDefaultOptions () {
    return {
      duration: 0,
      position: 0,
      skippable: false,
      skipOffsetRemaining: 0,
      skipEnabled: false
    };
  }

  attach (element) {
    super.attach(element);

    this.$('.iono-advert-skip').addEventListener('click', this.onskipclick);

    this.player.on('adstart', this.onadstart);
    this.player.on('adtimeupdate', this.onadtimeupdate);
    this.player.on('adskippable', this.onadskippable);
  }

  detach () {
    if (!this.isAttached()) return;

    this.player.off('adstart', this.onadstart);
    this.player.off('adtimeupdate', this.onadtimeupdate);
    this.player.off('adskippable', this.onadskippable);

    this.$('.iono-advert-skip').removeEventListener('click', this.onskipclick);

    super.detach();
  }

  render () {
    return `
      <div class="iono-advert-controls">
        ${progressIndicator}
        <button class="iono-button iono-advert-skip">${this.locale.lang('advertising.skip')} ⇢</button>
      </div>
    `;
  }

  update (changed = []) {
    if (changed.includes('position') || changed.includes('duration')) {
      // this.updatePosition();
      this.updateProgress();
      this.updateSkipButton();
    } else if (changed.includes('skippable') || changed.includes('skipOffsetRemaining') || changed.includes('skipEnabled')) {
      this.updateSkipButton();
    }
  }

  updateProgress () {
    const progress = this.props.position / this.props.duration;
    this.$('.iono-ad-progress').setAttribute('stroke-dashoffset', `${progressIndicatorCirc * (1 - progress)}px`);
  }

  // updatePosition () {
  //   this.$('.iono-position').textContent = iono.Player.formatSeconds(
  //     this.props.duration - this.props.position * -1
  //   );
  // }

  updateSkipButton () {
    const $button = this.$('.iono-advert-skip');

    if (this.props.skipEnabled) {
      if (this.props.skippable) {
        $button.textContent = `${this.locale.lang('advertising.skip')} ⇢`;
        $button.removeAttribute('disabled');
      } else {
        $button.textContent = `${this.locale.lang('advertising.skip')} (${this.props.skipOffsetRemaining | 0}s)`;
        $button.setAttribute('disabled', true);
      }
    } else {
      $button.setAttribute('hidden', true);
    }
  }

  // ui events

  onskipclick (event) {
    event.preventDefault();
    return this.player.skipad();
  }

  // player events

  onadstart () {
    this.setProps({
      position: this.player.getAdPosition() | 0,
      duration: this.player.getAdDuration(),
      skippable: this.player.isAdSkippable(),
      skipOffsetRemaining: this.player.getAdSkipOffsetRemaining(),
      skipEnabled: this.player.getAdSkipOffset() !== -1
    });
  }

  onadtimeupdate (event) {
    this.setProps({
      position: this.player.getAdPosition() | 0,
      duration: this.player.getAdDuration(),
      skipOffsetRemaining: this.player.getAdSkipOffsetRemaining()
    });
  }

  onadskippable (event) {
    this.setProp('skippable', true);
  }
}
